import React from "react";

type EmailIconProps = React.SVGProps<SVGSVGElement>;

export const EmailIcon = ({
  width = 20,
  height = 20,
  ...props
}: EmailIconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.3333 5.00065C18.3333 4.08398 17.5833 3.33398 16.6666 3.33398H3.33329C2.41663 3.33398 1.66663 4.08398 1.66663 5.00065V15.0007C1.66663 15.9173 2.41663 16.6673 3.33329 16.6673H16.6666C17.5833 16.6673 18.3333 15.9173 18.3333 15.0007V5.00065ZM16.6666 5.00065L9.99996 9.16732L3.33329 5.00065H16.6666ZM16.6666 15.0007H3.33329V6.66732L9.99996 10.834L16.6666 6.66732V15.0007Z" fill="#253858"/>
    </svg>
    
  
);

export default EmailIcon;
